import fetch from "@lottoasean/fetch-utils";

export const fetchVarieties = ({ params, ...rest }) => {
  return fetch({
    url: 'varieties',
    method: "GET",
    params,
    ...rest
  });
};

export const fetchVariety = ({ id, params, ...rest }) => {
  return fetch({
    url: `varieties/${id}`,
    method: "GET",
    params,
    ...rest
  });
};

export const updateVariety = ({ id, data, ...rest }) => {
  return fetch({
    url: `varieties/${id}`,
    method: "PUT",
    data,
    ...rest
  });
};
